import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import DashboardHeader from './components/HeaderACV'; 
import HomeInventoryContent from './components/HomeCCO';
import OrizonFooter from './components/OrizonFooter'; 
import Icon from '../../components/AppIcon'; 

const CCOHomePage = () => {
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({ nome: '', ruolo: '' });

  useEffect(() => {
    fetchAdminData();
  }, []);

  const fetchAdminData = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profilo } = await supabase
          .from('profili')
          .select('nome, cognome, ruolo')
          .eq('id', user.id)
          .single();
        
        if (profilo) {
          setAdminData({ 
            nome: `${profilo.nome} ${profilo.cognome}`, 
            ruolo: profilo.ruolo 
          });
        }
      }
    } catch (err) { 
      console.error("Errore caricamento dati:", err); 
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col gap-y-4 md:gap-y-6">
      <DashboardHeader />

      <main className="flex-grow w-full relative">
        {/* POVEĆAN PT (Padding Top): pt-24 za mobilne uređaje da ne zapinje za header */}
        <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 pt-24 md:pt-32 pb-12 lg:pb-24">
          
          {/* NAVIGACIJSKA DUGMAD (Back & Home) */}
          <div className="flex flex-wrap items-center gap-3 mb-10 animate-in fade-in slide-in-from-left-4 duration-700">
            <button 
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-muted/50 hover:bg-muted border border-border/50 transition-all group shadow-sm"
            >
              <Icon name="ArrowLeft" size={18} className="group-hover:-translate-x-1 transition-transform" />
              <span className="text-[10px] font-black uppercase tracking-widest">Indietro</span>
            </button>

            <button 
              onClick={() => navigate('/acv-home')}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-primary/10 hover:bg-primary/20 border border-primary/20 transition-all group text-primary shadow-sm shadow-primary/5"
            >
              <Icon name="Home" size={18} />
              <span className="text-[10px] font-black uppercase tracking-widest">Dashboard</span>
            </button>
          </div>

          <HomeInventoryContent />
        </div>
      </main>

      <OrizonFooter />
    </div>
  );
};

export default CCOHomePage;